export const rangeWithInterval = (from: number, to: number, step: number): number[] | undefined => {
  if (step < 1) {
    // trackException('---- TODO: FDDM: track exception')
    return undefined;
  }
  if (from > to) {
    // trackException('---- TODO: FDDM: track exception')
    return undefined;
  }

  const range: number[] = [];
  let nextEntry = from;
  do {
    range.push(nextEntry);

    nextEntry += step;
  } while (nextEntry <= to);

  return range;
};

export const unique = <T extends string | number | boolean | null | undefined | symbol | bigint>(
  array: T[],
) => [...new Set(array)];

/**
 * Removes duplicate elements from an array based on a predicate
 */
export const uniqueBy = <T extends object, K>(array: T[], predicate: (item: T) => K): T[] => {
  const seen = new Set<K>();
  return array.filter((item) => {
    const key = predicate(item);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export const intersect = <T>(array1: T[], array2: T[]): T[] =>
  array1.filter((value) => array2.includes(value));

export const isIntersect = <T>(array1: T[], array2: T[]): boolean =>
  intersect(array1, array2).length > 0;

type PrimitiveContentArray = (string | number | boolean | null | undefined)[];
export const primitiveArraysHaveEqualContents = (
  arr1: PrimitiveContentArray,
  arr2: PrimitiveContentArray,
): boolean => {
  const arr1Length = arr1.length;
  const arr2Length = arr2.length;

  if (arr1Length === 0 && arr2Length === 0) return true;
  if (arr1Length !== arr2Length) return false;

  const arr1Sorted = [...arr1].sort();
  const arr2Sorted = [...arr2].sort();

  return arr1Sorted.every((arr1Item, i) => arr1Item === arr2Sorted[i]);
};

export function tuplify<T>(ary: T[]): [T, ...T[]] {
  return [ary[0], ...ary.slice(1)] as [T, ...T[]];
}

/**
 * @description
 * Merges two arrays and skips duplicates
 */
export const merge = <T>(
  a: T[],
  b: T[],
  predicate: (a: T, b: T) => boolean = (a, b) => a === b,
): T[] => {
  const c = [...a];
  b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)));
  return c;
};

/**
 * @description
 * Resolves and returns the first item whose id is present in `availableIds`.
 * This avoids resolving every fallback id and helps prevent noisy "not found" logs.
 */
export const resolveFirstAvailable = <T>(
  ids: readonly string[],
  availableIds: Set<string>,
  resolver: (id: string) => T | undefined,
): T | undefined => {
  const firstAvailableId = ids.find((id) => availableIds.has(id));
  if (!firstAvailableId) {
    return undefined;
  }

  return resolver(firstAvailableId);
};
